module.exports = __webpack_public_path__ + "files/3bcddcdca1a11c9893d605c99a3b0e7d.png";